import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { signInUser } from "../actions/auth";
import styled from "styled-components";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
      overflow: "hidden",
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "55%",
    marginLeft: "30px",
    marginRight: "15px",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(1, 0, 2),
  },
  back: {
    "background-image": `url(${process.env.PUBLIC_URL}/images/2.png)`,
    "background-repeat": "no-repeat",
    "background-size": "cover",
    height: "90vh",
    "background-position": "center",
    overflow: "hidden",
  },
}));

function SignIn({ dispatch, error, user }) {
  if (user) {
    dispatch(push("/project"));
  }
  const classes = useStyles();
  const [values, setValues] = React.useState({
    username: "",
    password: "",
  });

  const handleClick = (event) => {
    event.preventDefault();
    const { username, password } = values;
    if (username && password) {
      dispatch(
        signInUser({
          username,
          password,
        })
      );
    }
  };

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  if (user) {
    return <h1>You already sighIn as {user.username}</h1>;
  }

  console.log(error, "error");

  return (
    <Grid container spacing={8} style={{ overflow: "hidden" }}>
      <Grid xs={12} sm={6}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <form className={classes.form} onSubmit={handleClick} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="username"
                label="username"
                username="username"
                value={values.name}
                onChange={handleChange("username")}
                autoFocus
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                value={values.name}
                onChange={handleChange("password")}
                autoComplete="current-password"
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                disabled={!values.username || !values.password}
              >
                Sign In
              </Button>

              {error && (
                <Typography color="error">
                  Password or Username is incorrect
                </Typography>
              )}

              <Grid container style={{ justifyContent: "center" }}>
                <Grid item/>
                <Grid item>
                  <Link
                    onClick={() => {
                      dispatch(push("/register"));
                    }}
                    variant="body2"
                    target="_blank"
                    style={{ cursor: "pointer "}}
                  >
                    {"Register"}
                  </Link>
                </Grid>
              </Grid>
            </form>
          </div>
        </Container>
      </Grid>
      <Grid xs={12} sm={6}>
        <div className={classes.back}></div>
      </Grid>
    </Grid>
  );
}
const mapStateToProps = (state) => state.auth;

// const mapStateToProps = state => ({
//   user: state.auth.user
// });
export default connect(mapStateToProps)(SignIn);
